<template>
  <nav class="nav">
    <div class="container container--no-padding">
      <ul class="nav__items">
        <li v-for="(item, index) in items"
            :key="index"
            v-if="item.display && item.name !== 'Fatura'">

          <a v-if="item.navigatable && !isNavBlocked && !isNavBlockable"
                       :class="{  current : index === current, active : index < current }"
                       class="link link--nav"
                       @click="$gm_router_push(item.handle)"
                       :disabled="isNavBlocked"
                       replace>
            {{ item.name }}
          </a>

          <a v-else
             :class="{  current : index === currentIndex, active : index < currentIndex }"
             class="link link--nav link--disabled">
            {{ item.name }}
          </a>

        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      currentIndex: 0
    };
  },
  computed: {
    ...mapGetters({
      items: 'timeline/getItems',
      current: 'timeline/getCurrent',
      isNavBlocked: 'timeline/getBlocked',
      simulationPackage: 'simulation/getPackage',
      mode: 'simulation/getMode',
      activePackageConfig: 'packages/getActivePackageConfig'
    }),
    itemsFiltered() {
      return this.items.filter(item => item.display);
    },
    currentFiltered() {
      const item = this.items[this.current];

      return this.itemsFiltered.indexOf(item);
    },
    isNavBlockable() {
      return this.activePackageConfig.features.disableTimelineNavigation;
    }
  },
  methods: {
    ...mapActions({
      onClick: 'timeline/setCurrent'
    })
  },
  watch: {
    currentFiltered(newValue, oldValue) {
      if (newValue < 0) {
        if (this.current > oldValue) {
          this.currentIndex = oldValue;
        } else {
          this.currentIndex = oldValue - 1;
        }
      } else {
        this.currentIndex = newValue;
      }
    },
    $route(to, from) {
      if (to.name !== from.name) {
        // Check if is navigating back
        const isBackNavigation =
          this.items.findIndex(el => el.handle.toLowerCase() === to.name.toLowerCase()) <
          this.items.findIndex(el => el.handle.toLowerCase() === from.name.toLowerCase());

        // Get item
        const element = this.items.find(el => el.handle.toLowerCase() === to.name.toLowerCase());

        // Get item's "parent" position
        const position = !element.display && isBackNavigation ?
          this.items.findIndex(el => el === element) - 1 : this.items.findIndex(el => el === element);

        this.onClick(position);
      }
    }
  },
  mounted() {
    this.currentIndex = this.currentFiltered;
  }
};
</script>

<style lang="scss">
@import '../../assets/sass/settings/colors';

.nav {
  position: absolute;
  top: 6.25rem;
  display: flex;
  justify-content: center;

  width: 100%;

  z-index: 15;
  overflow: hidden;

  .device-kiosk & {
    top: 5.425rem;
  }

  &__items {
    position: relative;

    display: flex;
    justify-content: space-between;

    width: 100%;

    z-index: 1;

    > li {
      position: relative;

      flex: 1 0 0;

      text-align: center;

      > a {
        padding: .625rem;

        .device-kiosk & {
          padding: .75rem .625rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/app/components/Nav.vue